import styled from 'styled-components';

export const NotificationsBellContainer = styled.button`
  border: none;
  background-color: transparent;
  display: flex;
  flex-direction: row;
`;

export const NotificationsCounter = styled.div`
  margin-top: -6px;
  margin-left: -12px;
  background: ${({ theme }) => theme.colors.verdigris};
  color: ${({ theme }) => theme.colors.eerieBlack};
  z-index: 10;
  border-radius: ${({ theme }) => theme.radius.m};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  letter-spacing: 0.5px;
  text-align: center;
  padding: ${({ theme }) => theme.spacing.xxs}
    ${({ theme }) => theme.spacing.xs};
    height: ${({ theme }) => theme.spacing.sm};
`;
